/**
 * Define action type for units module
 */
export const GET_TASKS = 'course_tasks/GET_TASKS';
export const GET_TASKS_SUCCESS = 'course_tasks/GET_TASKS_SUCCESS';
